import * as React from 'react'
import { SVGProps } from 'react'

const SvgAvatar2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 83 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M41.4 82.8c22.864 0 41.4-18.535 41.4-41.4S64.265 0 41.4 0 0 18.535 0 41.4c0 22.864 18.535 41.4 41.4 41.4Z"
      fill="#EAEAEA"
    />
    <mask
      id="avatar2_svg__a"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={83}
      height={83}
    >
      <path
        d="M41.4 82.8c22.864 0 41.4-18.535 41.4-41.4S64.265 0 41.4 0 0 18.535 0 41.4c0 22.864 18.535 41.4 41.4 41.4Z"
        fill="#EAEAEA"
      />
    </mask>
    <mask
      id="avatar2_svg__b"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={83}
      height={83}
    >
      <path
        d="M41.4 82.8c22.864 0 41.4-18.535 41.4-41.4S64.265 0 41.4 0 0 18.535 0 41.4c0 22.864 18.535 41.4 41.4 41.4Z"
        fill="#EAEAEA"
      />
    </mask>
    <g mask="url(#avatar2_svg__b)">
      <path
        d="M50.993 17.402s4.931-.229 4.682 5.606c-.362 8.462-2.176 16.66-6.857 18.173-4.68 1.513-4.862-7.92-4.862-7.92l7.037-15.86Z"
        fill="#120284"
      />
      <path
        d="M51.87 18.092s.464-5.641-9.797-6.075c-10.261-.433-14.87 7.305-13.38 14.984 1.491 7.679 2.495 12.78 6.387 13.432 3.891.651 8.877-7.173 8.877-7.173l7.912-15.168Z"
        fill="#120284"
      />
      <path
        d="M54.295 55.197c-2.722 2.265-5.357 5.157-7.839 5.907h-.018c-8.188 2.463-14.711-3.46-17.25-5.586.185-.072.367-.14.549-.215a9.02 9.02 0 0 0 1.376-.689 11.157 11.157 0 0 0 2.095-1.651c4.1-4.124 3.196-9.982 3.196-9.982h11.488c-.13 1.536-.115 3.081.046 4.614.23 2.272.826 3.839 2.249 5.155.953.881 2.274 1.651 4.108 2.447Z"
        fill="#C4C4F7"
      />
      <path
        d="M47.936 47.596c-.672 1.15-1.635 1.963-3 2.076-5.352.443-8.363-4.813-8.3-5.299l.278-1.392H47.89c-.13 1.536-.114 3.081.046 4.614Z"
        fill="#120284"
      />
      <path
        d="M55.144 32.929c0-1.5-1.06-2.715-2.366-2.715-1.307 0-2.366 1.219-2.366 2.715 0 1.496 1.06 3.38 2.366 3.38s2.366-1.884 2.366-3.38Z"
        fill="#C4C4F7"
      />
      <path
        d="m52.157 33.86-.166-.018c0-.018.203-1.788 1.846-1.832v.168c-1.494.04-1.678 1.665-1.68 1.682Z"
        fill="#120284"
      />
      <path
        d="M53.78 33.607c-.281-.29-.567-.425-.852-.411-.43.025-.723.4-.726.404l-.133-.102c.014-.017.34-.443.848-.468.342-.02.665.135.982.46l-.12.117Z"
        fill="#120284"
      />
      <path
        d="M28.867 32.929c0-1.5 1.059-2.715 2.365-2.715 1.307 0 2.366 1.219 2.366 2.715 0 1.496-1.06 3.38-2.368 3.38-1.308 0-2.363-1.884-2.363-3.38Z"
        fill="#C4C4F7"
      />
      <path
        d="m32.116 33.86.167-.018c0-.018-.203-1.788-1.847-1.832v.168c1.492.04 1.68 1.665 1.68 1.682Z"
        fill="#120284"
      />
      <path
        d="M30.493 33.607c.28-.29.566-.425.85-.411.431.025.724.4.727.404l.133-.102c-.014-.017-.34-.443-.849-.468-.341-.02-.665.135-.981.46l.12.117Z"
        fill="#120284"
      />
      <path
        d="M48.77 43.354c-1.753 2.013-3.972 3.31-6.634 3.267-2.66.043-4.881-1.254-6.634-3.267a.468.468 0 0 0-.031-.038c-3.14-3.97-3.78-9.751-2.93-16.632.613-4.951 5.281-6.87 7.873-7.56 1.128-.3 2.315-.3 3.444 0 2.591.69 7.26 2.609 7.873 7.56.853 6.904.208 12.7-2.961 16.67Z"
        fill="#C4C4F7"
      />
      <path
        d="M45.718 33.597a.57.57 0 1 0 0-1.139.57.57 0 0 0 0 1.14ZM38.193 33.597a.57.57 0 1 0 0-1.139.57.57 0 0 0 0 1.14ZM48.758 28.294s-1.366.056-3.16.07c-1.794.015-2.257-.014-2.096-.742.16-.728 1.96-.713 3.082-.462 1.123.252 2.174 1.134 2.174 1.134ZM35.02 28.294s1.366.056 3.16.07c1.794.015 2.257-.014 2.096-.742-.16-.728-1.96-.713-3.082-.462-1.123.252-2.175 1.134-2.175 1.134ZM41.757 37.024c-.205 0-.408-.032-.52-.136a.303.303 0 0 1-.089-.285c.082-.523.387-2.598.39-2.62l.166.025c0 .021-.307 2.098-.39 2.62a.138.138 0 0 0 .037.137c.156.145.698.09 1.004.021l.038.163a3.279 3.279 0 0 1-.636.075ZM42.326 38.248a2.992 2.992 0 0 1-.606-.055.094.094 0 0 1-.058-.04.092.092 0 0 1 .03-.128.094.094 0 0 1 .07-.012c.083.019 2.105.457 3.145-1.45a.093.093 0 0 1 .092-.049.095.095 0 0 1 .063.035.092.092 0 0 1 .02.068.093.093 0 0 1-.011.035c-.75 1.37-2.001 1.596-2.745 1.596ZM43.612 38.642a.093.093 0 0 1-.097-.084.093.093 0 0 1 .079-.1c.14-.028.275-.078.398-.15a.094.094 0 0 1 .133.104.094.094 0 0 1-.038.057c-.142.082-.297.14-.458.172l-.017.001ZM51.11 23.69l.625 9.335.673-3.147s2.005-4.182-1.298-6.188ZM33.161 22.597l-.88 10.428-.418-3.143s-2.005-4.186 1.298-7.285Z"
        fill="#120284"
      />
      <path
        d="M51.646 27.35s-.776-1.72-2.913-5.277c0 0-9.39 6.28-16.828 3.828 0 0-1.1-2.918 1.905-5.466 3.003-2.547 6.094-4.321 10.555-2.866 4.461 1.455 8.509 5.553 7.281 9.782Z"
        fill="#120284"
      />
      <path
        d="M49.173 22.164s-.181 2.032 1.699 5.278c0 0-1.6-1.81-2.153-4.854 0 0-3.52 3.671-7.432 4.338 0 0 3.822-.546 7.341-5.156l.545.394Z"
        fill="#120284"
      />
      <path
        d="m82.743 97.89-.06.2H.665c-2.986-18.208 3.866-37.994 25-42.084.672-.131 1.36-.243 2.064-.333.478-.063.964-.11 1.459-.155l.271-.11.274-.111a9.12 9.12 0 0 0 1.376-.69 11.115 11.115 0 0 0 2.096-1.652c2.279 1.22 8.31 3.507 16.979-.213.953.887 2.273 1.652 4.1 2.448 0 0 .718.078 1.93.333.487.104 1.051.238 1.68.41h.013c7.472 2.03 24.023 9.197 25.696 32.966.248 3.346-.083 6.326-.86 8.99Z"
        fill="#383FCE"
      />
      <path
        d="M56.567 72.034c-.04.061-.081.121-.123.18-2.484 3.592-6.194 5.918-9.211 7.328a7.566 7.566 0 0 1-.197.09c-2.762 1.27-4.899 1.765-4.899 1.765a38.128 38.128 0 0 1-5.3-1.945l-.197-.093c-4.354-2.036-7.196-4.592-9.006-7.295-.038-.061-.08-.121-.116-.182-2.613-4.016-2.973-8.34-2.631-11.771.006-.074.015-.145.02-.222.146-1.314.4-2.614.759-3.887.672-.133 1.36-.244 2.063-.332.478-.063.965-.115 1.459-.156.183-.073.365-.141.546-.215.478-.19.938-.421 1.377-.69a11.163 11.163 0 0 0 2.095-1.65c2.28 1.218 8.31 3.508 16.979-.213.953.886 2.274 1.65 4.1 2.446 0 0 .718.079 1.93.34.486.104 1.05.238 1.679.41a25.089 25.089 0 0 1 1.021 3.943c.014.072.027.143.036.213.816 5-.351 8.91-2.384 11.936Z"
        fill="#120284"
      />
      <path
        d="m42.2 64.01 14.363 8.023-.123.18L42.094 64.2l5.134 15.34a7.257 7.257 0 0 1-.197.09l-5.124-15.318-5.07 15.14-.198-.094 5.074-15.157-14.079 7.862c-.038-.061-.08-.121-.116-.182l14.089-7.867-16.72-3.9c.006-.075.015-.146.02-.222l17 3.965 17.018-3.97c.013.072.027.143.036.213L42.2 64.01Z"
        fill="#5661E2"
      />
      <path
        d="M42.137 77.203c-19.985-7.665-12.949-21.685-12.949-21.685.183-.072.365-.14.546-.215.478-.19.938-.42 1.377-.69a11.157 11.157 0 0 0 2.095-1.65c2.28 1.219 8.31 3.508 16.979-.213.953.886 2.274 1.651 4.1 2.447 6.988 15.018-12.148 22.006-12.148 22.006Z"
        fill="#fff"
      />
      <path
        d="M82.743 97.89c.807-33.896-24.446-41.823-24.835-41.942 7.465 2.026 24.035 9.187 25.707 32.97.237 3.327-.095 6.306-.872 8.973Z"
        fill="#120284"
      />
      <path
        d="M41.646 59.99a20.95 20.95 0 0 1-4.264-.443c-4.063-.848-6.744-2.626-6.77-2.644l.122-.18c.025.017 2.677 1.774 6.701 2.614 3.709.775 9.379.897 15.325-2.89l.11.185c-4.04 2.574-7.956 3.358-11.224 3.358Z"
        fill="#C4C4F7"
      />
    </g>
  </svg>
)

export default SvgAvatar2
